export default __webpack_public_path__ + "static/media/logo-universitas-binawan.27074d0f.png";